import React, { ReactElement } from "react";
import { language } from "../stores/18nStore";

interface Props {
  state: boolean;
  setStates?: (value: React.SetStateAction<boolean>) => void;
  title: string;
  paragraph: string;
  disabled?: true;
  partners?: { name: string; url?: string }[];
}

export default function CookiesSettingButton({
  state,
  setStates,
  title,
  paragraph,
  disabled,
  partners,
}: Props): ReactElement {
  return (
    <>
      <div className="cookies-each-point">
        <div className="cookies-each-point-flexed">
          <h4>{language(title)}</h4>
          <label className="switch-cookies">
            <input
              disabled={disabled}
              type="checkbox"
              onChange={() => (setStates ? setStates(!state) : null)}
              checked={state}
            />
            <span
              className={
                disabled ? "sliderdisabeled rounddisabeled" : "slider round"
              }
            ></span>
          </label>
        </div>
      </div>
      <div className="cookies-setting-subtitle-button">
        <p>{language(paragraph)}</p>
      </div>
      {partners && partners.length > 0 && (
        <div className="cookies-partners-list">
          <span className="cookies-partners-label">
            {language("cookiesPartners")}
          </span>{" "}
          {partners.map((each, index) => (
            <React.Fragment key={each.name}>
              {index > 0 && " · "}
              {each.url ? (
                <a href={each.url} target="_blank" rel="noreferrer">
                  {each.name}
                </a>
              ) : (
                each.name
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
}
